import React from 'react'
import axios from 'axios'
import {
  Button, Card, Modal, Col, Form, Icon,Input,Row,
  Table, TimePicker, DatePicker, Switch, Cascader,
  notification, InputNumber,
} from 'antd'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {fetchUsers} from 'appRedux/actions/Users'

const FormItem = Form.Item
const AUTH_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8'

class Basic extends React.Component {

  state = {
    visible: false,
    id: '',
    result:[]
  }  

  showdetails = id => {
    axios({
      method: 'get',
      url: `https://admingreenerapp.crsostenible.com/api/public/api/app/billing/get/${id}`,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AUTH_TOKEN
      }
    })
    //.then(request => console.log(request.data))
  .then((request) => {this.setState({result: request.data.data})
  })
  .catch(error => alert(error.message))
  }


  showModal = () => {
    this.setState({
      visible: true,
      id: this.props.recording.id,
      name: this.props.recording.name,
      total: this.props.recording.total,     
    })
  }

  handleCancel = e => {
    this.setState({
      id: '',
      name: '',
      total: '',
    })

    this.props.fetchUsers()
    this.setState({visible: false})
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'El producto se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al cambiar el producto.',
      })
    }
  }

  render() {
    const columns = [
          
      {
        title: 'Ultímos 4 dígitos',
        dataIndex: 'last_numbers',
        key: 'last_numbers',
      },
      {
        title: 'Año',
        dataIndex: 'year',
        key: 'year',
      },
      {
        title: 'Mes',
        dataIndex: 'month',
        key: 'month',
      },
  
    ]

    return (
      <div>
        <Button type="primary"
        onClick={ () => {
        this.showModal()
        this.showdetails(this.props.recording.id)
        }}>
        Método de pago
        </Button>
        <Modal

          afterClose={() => this.props.fetchUsers()}
          okText="Regresar"
          cancelText="Regresar"
          title=""
          cancelButtonProps={{ style: { display: 'none' } }}
          visible={this.state.visible}
          onOk={this.handleCancel}
          //onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Método de pago">
          <div id="payment_data"style={{position:'relative', transform: 'translate(115px, 9px)'}}>

              <Row>
              <Col lg={30} md={30} sm={30} xs={30}>
                  <Table
                    className="gx-table-responsive"
                    columns={columns}
                    dataSource={this.state.result}
                    size="middle" 
                    pagination={false} 
                  />
                </Col>
                </Row>
                </div>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, orders}) {
  return {
    placeStores,
    orders,
  }
}
export default connect(
  mapStateToProps,
  {fetchUsers},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Admin/PaymentDetails.js